import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import ElementUI from 'element-ui'
import MavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import '@/style/index.scss'
import '@/router/RouterGuard'
import Cookies from 'js-cookie'

Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV === 'development'
Vue.use(ElementUI)
Vue.use(MavonEditor)


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
